import {queryOptions, useQuery} from '@tanstack/react-query'
import {
	getPermitIntake,
	getPermitIntakeDaily,
	getWorkflowsDashboard,
	type IntakeBucket,
} from '@/lib/api/monitoring'

export const workflowsDashboardQueryOptions = (historyCount = 90) =>
	queryOptions({
		queryKey: ['workflows', 'dashboard', historyCount] as const,
		queryFn: async () => (await getWorkflowsDashboard(historyCount)).data,
		staleTime: 30_000,
		refetchInterval: 5 * 60_000,
	})

export function useWorkflowsDashboard(historyCount = 90) {
	return useQuery(workflowsDashboardQueryOptions(historyCount))
}

export const permitIntakeQueryOptions = () =>
	queryOptions({
		queryKey: ['workflows', 'permit-intake'] as const,
		queryFn: async () => (await getPermitIntake()).data,
		staleTime: 30_000,
		refetchInterval: 5 * 60_000,
	})

export function usePermitIntake() {
	return useQuery(permitIntakeQueryOptions())
}

export const permitIntakeDailyQueryOptions = (
	year: number,
	month: number,
	bucket: IntakeBucket,
) =>
	queryOptions({
		queryKey: [
			'workflows',
			'permit-intake',
			'daily',
			year,
			month,
			bucket,
		] as const,
		queryFn: async () => (await getPermitIntakeDaily(year, month, bucket)).data,
		staleTime: 30_000,
		refetchInterval: 5 * 60_000,
	})

export function usePermitIntakeDaily(
	year: number,
	month: number,
	bucket: IntakeBucket,
) {
	return useQuery(permitIntakeDailyQueryOptions(year, month, bucket))
}

export {
	infrastructureBackupsQueryOptions,
	useInfrastructureBackups,
} from './infrastructure-backups'
export {
	useRawSourceContent,
	useWorkflowRunArtifacts,
} from './run-artifacts'
export {useWorkflowTrigger} from './trigger-workflow'
